export const getAliasByType = {
	A: (alias) => `${alias.firstName} ${alias.lastName}`,
	'ID type': (alias) => alias.idCode,
	DOB: (alias) => alias.dob,
	DL: (alias) => alias.identifier,
	N: (alias) => alias.middleName
};
